<div (click)="onClick($event)" class="wrapper">
  <div [title]="btnTitle" class="map-control-btn" [ngClass]="{ 'mobile-btn': isMobile }">
    <i class="material-symbols-outlined venue-map-icon" [ngClass]="{ 'active': toggleState }">map</i>
  </div>
</div>
